<template>
  <form class="user-form">
    <b-form-group label="Имя пользователя">
      <b-input
        type="text"
        v-model="value.name"
        required
        placeholder="Введите имя пользователя"
      />
    </b-form-group>
    <b-form-group label="Логин пользователя">
      <b-input
        type="text"
        v-model="value.login"
        required
        placeholder="Введите логин пользователя"
      />
    </b-form-group>
    <b-form-group label="Пароль">
      <b-input
        type="password"
        v-model="password"
        placeholder="Оставьте пустым, если не планируете менять пароль"
      />
    </b-form-group>
    <b-form-group label="Права пользователя">
      <item-picker
        v-model="pickedRights"
        :items="rights"
        :fields="rightsRolesTableFields"
        picked-title="Права пользователя"
        unpicked-title="Доступные права"
      />
    </b-form-group>
    <b-form-group label="Роли пользователя">
      <item-picker
        v-model="pickedRoles"
        :items="roles"
        :fields="rightsRolesTableFields"
        picked-title="Роли пользователя"
        unpicked-title="Доступные роли"
      />
    </b-form-group>
  </form>
</template>

<script>
import UserModel from "@/components/Forms/User/models/userModel";
import ItemPicker from "@/components/Forms/ItemPicker";
import UserRightModel from "@/components/Forms/User/models/userRightModel";
import UserRoleModel from "@/components/Forms/User/models/userRoleModel";

let rightsRolesTableFields = [
  {
    key: "display_name",
    label: "Название",
    search: true
  }
];

export default {
  components: { ItemPicker },
  props: {
    value: {
      type: UserModel,
      required: false,
      default: () => new UserModel()
    }
  },
  data() {
    return {
      rightsRolesTableFields,
      rights: [],
      rightsLoading: false,
      roles: [],
      rolesLoading: false,
      password: null
    };
  },
  computed: {
    pickedRights: {
      get: ({ rights, value }) =>
        rights.filter(({ id }) =>
          value.rights.map(({ id }) => Number(id)).includes(Number(id))
        ),
      set: function(rights) {
        this.value.rights = rights;
      }
    },
    pickedRoles: {
      get: ({ roles, value }) =>
        roles.filter(({ id }) =>
          value.roles.map(({ id }) => Number(id)).includes(Number(id))
        ),
      set: function(roles) {
        this.value.roles = roles;
      }
    },
    login: ({ value }) => value.login,
    hash: ({ login, password, $store }) => {
      if (
        password !== null &&
        password.length > 5 &&
        login !== null &&
        login.length > 2
      )
        return $store.getters["user/getHash"](login, password);
      else return null;
    }
  },
  watch: {
    hash: {
      handler(val) {
        this.value.hash = val;
      }
    }
  },
  async created() {
    this.rights = (await this.axios.get("/users/rights")).data.rights.map(
      right => new UserRightModel(right)
    );
    this.roles = (await this.axios.get("/users/roles")).data.roles.map(
      role => new UserRoleModel(role)
    );
  }
};
</script>
